/* Birthflower selector — month / piece / metal picker.
   Markup contract: sections/birthflower-selector.liquid.
   Product data (price, image, URL) is fetched live from
   /products/<handle>.js and cached, so nothing goes stale. */
(function () {
  'use strict';

  var PATTERNS = {
    colier: { g: 'colier-din-argint-birth-flower-golden-{slug}', s: 'colier-din-argint-birth-flower-silver-{slug}' },
    inel: { g: 'inel-din-argint-birth-flower-golden-{slug}', s: 'inel-din-argint-birth-flower-{slug}' },
    bratara: { g: 'brațara-șnur-din-aur-birth-flower-{slug}', s: 'brațara-șnur-din-aur-alb-birth-flower-{slug}' },
    pandantiv: { g: 'pandantiv-din-aur-birth-flower-{slug}', s: 'pandantiv-din-aur-alb-birth-flower-{slug}' }
  };
  var EXCEPTIONS = {
    'colier|g|may-lily': 'colier-din-argint-golden-birthflower-may-lily',
    'colier|s|may-lily': 'colier-din-argint-silver-birth-flower-may-lily',
    'inel|g|may-lily': 'inel-din-argint-birth-flower-golden-may-lilly'
  };
  var TYPE_KEYS = ['colier', 'inel', 'bratara', 'pandantiv'];
  var MONTH_WORDS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  /* Locale-invariant product id -> "type|metal|monthIndex".
     Generated from the canonical Romanian handles; used to resolve
     translated URL handles on non-Romanian market domains. */
  var ID_KEYS = {"7156038893739":"colier|g|0","7156038041771":"colier|g|1","7156037419179":"colier|g|2","7156037615787":"colier|g|3","7156020084907":"colier|g|4","7156038631595":"colier|g|5","7156038303915":"colier|g|6","7156038402219":"colier|g|7","7156036829355":"colier|g|8","7156037222571":"colier|g|9","7156036993195":"colier|g|10","7156037845163":"colier|g|11","7156062650539":"colier|s|0","7156063076523":"colier|s|1","7156063305899":"colier|s|2","7156064256171":"colier|s|3","7156062486699":"colier|s|4","7156062814379":"colier|s|5","7156063895723":"colier|s|6","7156063764651":"colier|s|7","7156064518315":"colier|s|8","7156064387243":"colier|s|9","7156063502507":"colier|s|10","7156064059563":"colier|s|11","9920969802071":"inel|g|0","7236341792939":"inel|g|1","8508608020823":"inel|g|2","7236340646059":"inel|g|3","7236342612139":"inel|g|4","7236347232427":"inel|g|5","7236343496875":"inel|g|6","7236344840363":"inel|g|7","7236339499179":"inel|g|8","8508673098071":"inel|g|9","8508630368599":"inel|g|10","8508622045527":"inel|g|11","7236337041579":"inel|s|0","7236329373867":"inel|s|1","8508612673879":"inel|s|2","7236328259755":"inel|s|3","7236331405483":"inel|s|4","7236335927467":"inel|s|5","7236332781739":"inel|s|6","7236333928619":"inel|s|7","7236324753579":"inel|s|8","8508673818967":"inel|s|9","8508668117335":"inel|s|10","8508628042071":"inel|s|11","7480125522091":"bratara|g|0","7480575459499":"bratara|g|1","7480128209067":"bratara|g|2","7480126734507":"bratara|g|3","7480622448811":"bratara|g|4","7480636309675":"bratara|g|5","7480592400555":"bratara|g|6","7469677281451":"bratara|g|7","7480538595499":"bratara|g|8","7480118771883":"bratara|g|9","7480610455723":"bratara|g|10","7480553636011":"bratara|g|11","7480126144683":"bratara|s|0","7480581914795":"bratara|s|1","7480128503979":"bratara|s|2","7480127258795":"bratara|s|3","7480625332395":"bratara|s|4","7480647844011":"bratara|s|5","7480603607211":"bratara|s|6","7480117166251":"bratara|s|7","7480546230443":"bratara|s|8","7480122933419":"bratara|s|9","7480615436459":"bratara|s|10","7480567660715":"bratara|s|11","7480719311019":"pandantiv|g|0","7481292128427":"pandantiv|g|1","7481362579627":"pandantiv|g|2","7481247432875":"pandantiv|g|3","7481180553387":"pandantiv|g|4","7481191006379":"pandantiv|g|5","7480713805995":"pandantiv|g|6","7469669318827":"pandantiv|g|7","7481208864939":"pandantiv|g|8","7481263587499":"pandantiv|g|9","7481405735083":"pandantiv|g|10","7481323225259":"pandantiv|g|11","7480719802539":"pandantiv|s|0","7481315492011":"pandantiv|s|1","7481370050731":"pandantiv|s|2","7481256083627":"pandantiv|s|3","7481183568043":"pandantiv|s|4","7481194643627":"pandantiv|s|5","7480715116715":"pandantiv|s|6","7480711741611":"pandantiv|s|7","7481222791339":"pandantiv|s|8","7481269977259":"pandantiv|s|9","7481419333803":"pandantiv|s|10","7481349537963":"pandantiv|s|11"};

  function handleFor(type, metal, slug) {
    var exception = EXCEPTIONS[type + '|' + metal + '|' + slug];
    if (exception) return exception;
    return PATTERNS[type][metal].replace('{slug}', slug);
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'RON';
    var lang = document.documentElement.lang || 'ro';
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return Math.round(cents / 100) + ' ' + currency;
    }
  }

  function imageUrl(product, width) {
    var src = product.featured_image || (product.images && product.images[0]);
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function init(root) {
    var configEl = root.querySelector('[data-bf-config]');
    if (!configEl) return;
    var cfg;
    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    var months = cfg.months.filter(function (m) { return m.slug; });
    if (!months.length) return;

    var state = {
      sel: Math.min(new Date().getMonth(), months.length - 1),
      type: 'colier',
      metal: cfg.defaultMetal === 's' ? 's' : 'g'
    };
    var cache = {};
    var indexPromise = null;

    function fetchByHandle(handle) {
      if (cache[handle]) return cache[handle];
      cache[handle] = fetch(cfg.rootUrl + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
      return cache[handle];
    }

    /* Locale fallback: on markets with translated URL handles the
       Romanian patterns 404. Build a handle index once from the
       collection's products.json by matching locale-invariant
       product ids, then fetch the resolved localized handle's .js
       for correct market pricing. */
    function loadIndex() {
      if (indexPromise) return indexPromise;
      indexPromise = fetch(cfg.indexUrl)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var map = {};
          if (!data || !data.products) return map;
          data.products.forEach(function (p) {
            var key = ID_KEYS[String(p.id)];
            if (key && !map[key]) map[key] = p.handle;
          });
          return map;
        })
        .catch(function () { return {}; });
      return indexPromise;
    }

    function fetchProduct(type, metal, slug) {
      return fetchByHandle(handleFor(type, metal, slug)).then(function (product) {
        if (product) return product;
        var monthIndex = MONTH_WORDS.indexOf(slug.split('-')[0]);
        if (monthIndex === -1) return null;
        return loadIndex().then(function (map) {
          var localized = map[type + '|' + metal + '|' + monthIndex];
          return localized ? fetchByHandle(localized) : null;
        });
      });
    }

    function productUrl(product) {
      var rootPrefix = cfg.rootUrl.replace(/\/$/, '');
      return rootPrefix + product.url;
    }

    var els = {
      monthTabs: root.querySelectorAll('[data-bf-month]'),
      typeTabs: root.querySelectorAll('[data-bf-type]'),
      metalBtns: root.querySelectorAll('[data-bf-metal]'),
      cells: root.querySelectorAll('[data-bf-cell]'),
      single: root.querySelector('[data-bf-single]'),
      img: root.querySelector('[data-bf-img]'),
      set: root.querySelector('[data-bf-set]'),
      monthName: root.querySelector('[data-bf-month-name]'),
      typeName: root.querySelector('[data-bf-type-name]'),
      flower: root.querySelector('[data-bf-flower]'),
      flowerRo: root.querySelector('[data-bf-flower-ro]'),
      message: root.querySelector('[data-bf-message]'),
      piece: root.querySelector('[data-bf-piece]'),
      material: root.querySelector('[data-bf-material]'),
      priceRow: root.querySelector('[data-bf-price-row]'),
      price: root.querySelector('[data-bf-price]'),
      cta: root.querySelector('[data-bf-cta]')
    };

    function setPressed(list, isActive) {
      list.forEach(function (el, i) {
        el.setAttribute('aria-pressed', isActive(el, i) ? 'true' : 'false');
      });
    }

    function render() {
      render.isFirst = render.isFirst === undefined;
      var m = months[state.sel];
      var isSet = state.type === 'set';
      var renderToken = m.slug + '|' + state.type + '|' + state.metal;
      render.token = renderToken;

      setPressed(els.monthTabs, function (el) { return el.getAttribute('data-bf-month') === String(state.sel); });
      setPressed(els.cells, function (el) { return el.getAttribute('data-bf-cell') === String(state.sel); });
      setPressed(els.typeTabs, function (el) { return el.getAttribute('data-bf-type') === state.type; });
      setPressed(els.metalBtns, function (el) { return el.getAttribute('data-bf-metal') === state.metal; });

      els.monthName.textContent = m.month;
      els.typeName.textContent = isSet ? cfg.labels.set : cfg.types[state.type].label;
      els.flower.textContent = m.flowerEn;
      els.flowerRo.textContent = m.flowerRo;
      els.message.textContent = m.message;
      els.single.hidden = isSet;
      els.set.hidden = !isSet;

      if (isSet) {
        els.piece.textContent = cfg.labels.setPiece;
        els.material.textContent = state.metal === 'g' ? cfg.labels.setMatG : cfg.labels.setMatS;
        els.cta.textContent = cfg.labels.ctaSet;
        els.cta.href = cfg.setUrl;
        els.price.textContent = '…';
        Promise.all(TYPE_KEYS.map(function (key) { return fetchProduct(key, state.metal, m.slug); })).then(function (products) {
          if (render.token !== renderToken) return;
          var loaded = products.filter(Boolean);
          TYPE_KEYS.forEach(function (key, i) {
            var cellImg = root.querySelector('[data-bf-set-img="' + key + '"]');
            if (cellImg && products[i]) {
              cellImg.src = imageUrl(products[i], 600);
              cellImg.alt = products[i].title;
            }
          });
          if (loaded.length === TYPE_KEYS.length) {
            var total = loaded.reduce(function (sum, p) { return sum + p.price; }, 0);
            els.priceRow.hidden = false;
            els.price.textContent = cfg.labels.setPricePrefix + ' ' + money(total);
          } else {
            els.priceRow.hidden = true;
          }
        });
      } else {
        var type = cfg.types[state.type];
        els.piece.textContent = type.label + ' Birthflower — ' + m.flowerEn;
        els.material.textContent = state.metal === 'g' ? type.matG : type.matS;
        els.cta.textContent = cfg.labels.ctaProduct;
        if (!render.isFirst) els.price.textContent = '…';
        fetchProduct(state.type, state.metal, m.slug).then(function (product) {
          if (render.token !== renderToken) return;
          if (product) {
            var src = imageUrl(product, 900);
            els.img.alt = product.title;
            if (els.img.src !== src) {
              els.img.classList.add('is-loading');
              els.img.onload = function () { els.img.classList.remove('is-loading'); };
              els.img.src = src;
            }
            els.priceRow.hidden = false;
            els.price.textContent = money(product.price);
            els.cta.href = productUrl(product);
          } else {
            els.priceRow.hidden = true;
            els.cta.href = cfg.setUrl;
          }
        });
      }
    }

    root.addEventListener('click', function (event) {
      var target = event.target.closest('[data-bf-month], [data-bf-cell], [data-bf-type], [data-bf-metal], [data-bf-prev], [data-bf-next]');
      if (!target || !root.contains(target)) return;
      if (target.hasAttribute('data-bf-month')) {
        state.sel = parseInt(target.getAttribute('data-bf-month'), 10);
      } else if (target.hasAttribute('data-bf-cell')) {
        state.sel = parseInt(target.getAttribute('data-bf-cell'), 10);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (target.hasAttribute('data-bf-type')) {
        state.type = target.getAttribute('data-bf-type');
      } else if (target.hasAttribute('data-bf-metal')) {
        state.metal = target.getAttribute('data-bf-metal');
      } else if (target.hasAttribute('data-bf-prev')) {
        state.sel = (state.sel + months.length - 1) % months.length;
      } else if (target.hasAttribute('data-bf-next')) {
        state.sel = (state.sel + 1) % months.length;
      }
      render();
    });

    render();

    setTimeout(function () {
      months.forEach(function (m, i) {
        fetchProduct('pandantiv', 'g', m.slug).then(function (product) {
          var thumb = root.querySelector('[data-bf-thumb="' + i + '"]');
          if (thumb && product) {
            thumb.src = imageUrl(product, 400);
            thumb.alt = product.title;
          }
        });
      });
    }, 600);
  }

  function boot() {
    document.querySelectorAll('[data-birthflower-selector]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
